export const venueSchema = {
	schema: {
		title: 'venue schema',
		description: 'Venue Schema',
		version: 0,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			sfid: {
				type: 'string',
			},
			town_name_c: {
				type: 'string',
			},
			venue_name_c: {
				type: 'string',
			},
			venue_address_c: {
				type: 'string',
			},
			hotel_contact_no_c: {
				type: 'string',
			},
			hotel_contact_person_name_c: {
				type: 'string',
			},
			location_c: {
				type: 'string',
			},
			menu_inclusions_c: {
				type: 'string',
			},
		},
		required: [
			'id',
			'sfid',
			'town_name_c',
			'venue_name_c',
			'venue_address_c',
			'hotel_contact_no_c',
			'hotel_contact_person_name_c',
			'location_c',
			'menu_inclusions_c',
		],
	},
};
